webpackJsonp([197429686467972],{

/***/ 121:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/Vicentiu-Bacioiu.5bb759ca.jpg";

/***/ }),

/***/ 226:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _VicentiuBacioiu = __webpack_require__(121);
	
	var _VicentiuBacioiu2 = _interopRequireDefault(_VicentiuBacioiu);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var VicentiuBacioiu = function VicentiuBacioiu() {
	    return _react2.default.createElement(
	        'section',
	        { id: 'speaker', className: 'parallax-section' },
	        _react2.default.createElement(
	            'div',
	            { className: 'container' },
	            _react2.default.createElement('br', null),
	            _react2.default.createElement('br', null),
	            _react2.default.createElement('br', null),
	            _react2.default.createElement('br', null),
	            _react2.default.createElement('br', null),
	            _react2.default.createElement('br', null),
	            _react2.default.createElement(
	                'div',
	                { className: 'row' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'col-md-12 col-sm-12 wow fadeInUp', 'data-wow-delay': '0.1s' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'team-wrapper' },
	                        _react2.default.createElement(
	                            'h2',
	                            null,
	                            'Vicentiu Bacioiu'
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'row' },
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'col-md-6' },
	                                _react2.default.createElement('img', { src: _VicentiuBacioiu2.default, className: 'img-responsive', alt: 'Vicentiu Bacioiu' }),
	                                _react2.default.createElement(
	                                    'ul',
	                                    { className: 'social-icon' },
	                                    _react2.default.createElement(
	                                        'li',
	                                        null,
	                                        _react2.default.createElement('a', { href: 'https://www.linkedin.com/in/vicentiubacioiu/', target: '_blank', className: 'fa fa-linkedin wow fadeIn' })
	                                    )
	                                )
	                            ),
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'col-md-5' },
	                                _react2.default.createElement(
	                                    'p',
	                                    null,
	                                    'Vic is always on the lookout for the latest Web features. Having started his programming journey with JavaScript, he is currently digging deep in Angular and RxJS. While he\'s involved in most parts of the software creation process, his favorites are: defining the architecture of the application and picking the right colors and borders until the screen looks just right. ',
	                                    _react2.default.createElement('br', null),
	                                    'At Cognizant Softvision, being part of the Web Community, he gets the chance to share knowledge and grow people.'
	                                )
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'row' },
	                            _react2.default.createElement(
	                                'h4',
	                                null,
	                                'Talk: OAuth Unlocked - How it actually works'
	                            ),
	                            _react2.default.createElement(
	                                'p',
	                                null,
	                                'This session aims to describe how the OAuth standard works, go through the existing flows and see how they work and provide some tips on where to get started.'
	                            )
	                        )
	                    )
	                )
	            )
	        )
	    );
	};
	
	exports.default = VicentiuBacioiu;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-speakers-vicentiu-bacioiu-js-42f780a7b1914c224362.js